import React from "react";
import { Flex, ButtonGroup, IconButton, VStack, Text } from "@chakra-ui/react";
import {
  RiArrowLeftLine,
  RiArrowRightLine,
  RiSkipBackLine,
  RiSkipForwardLine,
} from "react-icons/ri";

interface CommentsPaginationProps {
  currentPage: number;
  totalPages: number;
  hasNextPage: boolean;
  paginationCount: number;
  isLoading: boolean;
  onFirstPage: () => void;
  onPreviousPage: () => void;
  onNextPage: () => void;
  onLastPage: () => void;
}

const CommentsPagination: React.FC<CommentsPaginationProps> = ({
  currentPage,
  totalPages,
  hasNextPage,
  paginationCount,
  isLoading,
  onFirstPage,
  onPreviousPage,
  onNextPage,
  onLastPage,
}) => {
  return (
    <Flex justify="space-between" align="center" w="full" p={2}>
      <ButtonGroup isAttached variant="ghost" size="sm">
        <IconButton
          icon={<RiSkipBackLine />}
          onClick={onFirstPage}
          isDisabled={currentPage === 0 || isLoading}
          aria-label="First page"
        />
        <IconButton
          icon={<RiArrowLeftLine />}
          onClick={onPreviousPage}
          isDisabled={currentPage === 0 || isLoading}
          aria-label="Previous page"
        />
      </ButtonGroup>

      <VStack spacing={0} align="center">
        <Text fontSize="xs" color="gray.500">
          Page {currentPage + 1}
          {totalPages > 0 && ` of ${totalPages}`}
        </Text>
        <Text fontSize="xs" color="gray.400">
          {paginationCount > 0 && `${paginationCount} total comments`}
        </Text>
      </VStack>

      <ButtonGroup isAttached variant="ghost" size="sm">
        <IconButton
          icon={<RiArrowRightLine />}
          onClick={onNextPage}
          isDisabled={!hasNextPage || isLoading}
          aria-label="Next page"
        />
        <IconButton
          icon={<RiSkipForwardLine />}
          onClick={onLastPage}
          isDisabled={!hasNextPage || isLoading}
          aria-label="Last page"
        />
      </ButtonGroup>
    </Flex>
  );
};

export default CommentsPagination;
